import { useContext } from 'react'

import { navigationContext } from 'modules/core/lib/navigation/context'

/**
 * Dear dev,
 * Welcome to navigation heaven! 🌄
 *
 * This `useNavigation` hook is in charge of getting the `navigation` object and transform it so we
 * can use it all around the app. Therefore, accessing it we will have the following object for each
 * location:
 *
 *  type BuiltLocation = {
 *    path: string
 *    fullPath: (...params: Params<LocationPath>) => string
 *    name?: string
 *    filter: (target: Model) => boolean
 *    icon?: MediumIcon
 *    ...Record<{ [key: string]: BuiltLocation }>
 *  }
 *
 * Using these, we can access each location attributes but we can also access each location children
 * directly. For instance, if I want to get the employees/:id/tasks location I can do:
 *
 *  navigation.employees.id.tasks.fullPath({ id: '1' }) // Outputs: `/employees/1/tasks`
 *
 * To get the full path.
 * On the other hand, I can also just access the short tasks path doing:
 *
 *  navigation.employees.id.tasks.path // Outputs: `path`
 */
export const useNavigation = () => {
  const value = useContext(navigationContext)

  if (!value) {
    throw new Error('useNavigation must be used within a NavigationProvider')
  }

  return value
}
